<template>
    <div class="waitHouse">
        <div class="top_wrap">
            <div class="key_top">
                <ul class="key_list">
                    <li class="conditions_list_item">
                        <el-input v-model="search.houseCode" placeholder="房源编号" @input="selectSearch(true)" clearable></el-input>
                    </li>
                    <li class="conditions_list_item">
                        <span style="min-width:30px;text-align: right">类型：</span>
                        <el-select v-model="search.transactionType" placeholder="不限" @change="selectSearch(true)" clearable>
                            <el-option v-for="(item,index) in HousingList" :key="index" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item many_item">
                        <span style="min-width:60px;">建筑类型：</span>
                        <el-select v-model="search.housingResourceType" multiple collapse-tags placeholder="不限" @change="selectSearch(true)" clearable>
                            <el-option v-for="(item,index) in houseTypeList" :key="index" :label="item.valueDesc" :value="item.value">
                            </el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <span style="min-width:48px;">录入人：</span>
                        <el-select v-model="search.submitEmployeeId" placeholder="请输入" @change="selectSearch(true)" filterable clearable>
                            <el-option v-for="(item,index) in employeeIdList" :key="index" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <span style="min-width:60px;">审批状态：</span>
                        <el-select v-model="search.status" placeholder="不限" @change="selectSearch(true)" clearable>
                            <el-option v-for="(item,index) in ApprovalList" :key="index" :label="item.statusName" :value="item.statusValue">
                            </el-option>
                        </el-select>
                    </li>
                    <li class="conditions_list_item">
                        <span>录入时间：</span>
                        <div class="idcode">
                            <el-date-picker v-model="search.submitTime" unlink-panels value-format="yyyy-MM-dd" type="daterange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right" @change="selectSearch(true)"></el-date-picker>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="KeyList" border style="width: 100%" :header-cell-style="setHeaderStyle" @row-dblclick="operation" @row-click="rowColorclick" highlight-current-row>
                <el-table-column prop="houseCode" label="房源编号">
                    <template slot-scope="scope">
                        <el-button :class="{rowColor:scope.row.houseCode===isRowColor&&scope.row.applyId===isapplyId}" type="text" size="medium" style="text-decoration:underline" @click="HousingDetails(scope.row.buildingInfoId,scope.row.housingProperty,scope.row.employeeId)">
                            {{scope.row.houseCode}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="transactionType" label="类型"></el-table-column>
                <el-table-column prop="buildingType" label="建筑类型"></el-table-column>
                <el-table-column prop="address" label="房源地址"></el-table-column>
                <el-table-column prop="area" label="面积（㎡）"></el-table-column>
                <el-table-column prop="price" label="价格"></el-table-column>
                <el-table-column prop="property" label="性质"></el-table-column>
                <el-table-column prop="houseCategory" label="房源类型"></el-table-column>
                <el-table-column prop="approvalStatus" label="审批状态"></el-table-column>
                <el-table-column prop="submitterName" label="录入人"></el-table-column>
                <el-table-column prop="submissionTime" label="录入时间"></el-table-column>
                <!--                <el-table-column prop="approvalOpinions" label="审批意见"></el-table-column>-->
            </el-table>
            <div class="footer_pages">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
            <el-dialog class="housing_solid" width="878px" title="实勘管理" :visible.sync="HousingSolidVisible">
                <div v-if="details.approvalStatusValue=='UNABLE'||details.approvalStatusValue=='AUDITED'||details.approvalStatusValue=='TO_BE_AUDITED'" style="display: flex;justify-content: flex-start;margin: 10px 30px 0 30px;">
                    <div>
                        <div v-if="details.approvalStatusValue=='UNABLE'" style="color: #FF0000;font-size: 14px;">{{details.applyRemark}}</div>
                        <div v-if="details.approvalStatusValue=='AUDITED'" style="color: #22CA85;font-size: 14px;">审批通过</div>
                        <div v-if="details.approvalStatusValue=='TO_BE_AUDITED'" style="color: #ff8000;font-size: 14px;">审批中</div>
                    </div>
                    <div style="color: #5E75E6;font-size: 14px;margin-left: 30px;cursor: pointer" @click="toApproveManage">查看审批详情>></div>
                </div>
                <!--房源信息-->
                <div class="houseMsg" style="color: #333333;font-size: 14px;margin: 20px 30px 38px 30px;">
                    <div class="houseMsg-item" style="display: flex;justify-content: space-between;margin-bottom: 20px;">
                        <div style="width: 228px;" >房源编号：<span style="color: #5E75E6;cursor: pointer" @click="HousingDetails(details.buildingInfoId,details.housingProperty,details.employeeId)">{{details.houseCode}}</span></div>
                        <div style="width: 250px;">类<span style="visibility: hidden">占位</span>型：{{details.transactionType}}</div>
                        <div style="width: 400px;">房源地址：{{details.address}}</div>
                    </div>
                    <div class="houseMsg-item" style="display: flex;justify-content: space-between">
                        <div style="width: 228px;">面<span style="visibility: hidden">占位</span>积：{{details.area}}m²</div>
                        <div style="width: 250px;">建筑类型：{{details.buildingType}}</div>
                        <div style="width: 400px;">房源类型 ：{{details.houseCategory}}</div>
                    </div>
                </div>
                <HousingSolid :append-to-body="true" @HousingSolidImgList="HousingSolidImgList" @removeHousingSolid="removeHousingSolid" :permisList="permisList" :details="details" v-if="HousingSolidVisible"></HousingSolid>
            </el-dialog>
        </div>
        <!-- 图片放大 -->
        <div class="mask" v-if="imgListShow1">
            <img class="close" @click="imgListShow1=false" src="../../assets/images/close.png" alt />
            <template>
                <el-carousel indicator-position="outside" :autoplay='false'>
                    <el-carousel-item v-for="(item,index) in imgList" :key="index">
                        <img :src="'http://'+item" />
                    </el-carousel-item>
                </el-carousel>
            </template>
        </div>
    </div>
</template>
<script type="text/javascript">
import { queryKey, communitynameQuery, employeeQuery, querySurveyList, checkStatusGet } from "@/api/manageCenter";
import { houseQuery, simpleTung, simpleUnit, queryApprovalHouseList, houseTypeDetail } from "@/api/houseManage";
import { dicGet } from "@/api";
import HousingSolid from "@/components/common/housingSolidmanage";
export default {
    name: "/shikanManage",
    components: {
        HousingSolid
    },
    data() {
        // let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            imgList: "",
            imgListShow1: false,//图片放大
            HousingSolidVisible: false,
            details: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: "当天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            KeyList: [],
            housingData: [], //小区列表
            simpleTungList: [],//栋座列表
            simpleUnitList: [],//单元列表
            level: "",
            isRowColor: "",
            permisList: [],
            total: 0,
            currentPage: 1,
            pageNumber: 1, //从第几条开始
            pageSize: 20, //显示条数
            ResidentialName: "", //选择的小区名字
            houseCode: "", //房源编号
            residentialAreaName: "", //小区名字
            keyId: "", //钥匙编号
            description: "", //备注
            HousingList: [], //房源状态列表
            houseTypeList: [],//建筑类型列表
            employeeIdList: [], //提交人
            ApprovalList: [], //审批状态
            //搜索
            search: {
                houseCode: "",//房源编号
                transactionType: "", //房源类型
                housingResourceType: [], //建筑类型
                submitEmployeeId: "",//提交人
                status: "",//审批状态
                submitTime: [],//提交时间
                // keyword: "", //房源编号
                // submitter: "", //提交人
                // approvalStatus: "", //审批状态
                // residentialAreaId: "",//小区编号
                // tungId: "",//栋座
                // unitId: "",//单元
                // date: [],//收钥匙时间
            },
            isapplyId:'',
        };
    },
    mounted() {
        // this.getlevel();//查询权限
        this.selectSearch(); //查询待审批房源列表
        this.getHousingCondition(); //房源状态
        this.gethouseTypeList(); //建筑类型
        this.getEmployeeIdList();//提交人列表
        this.getApprovalList();//审批状态列表
    },
    activated() {
        // this.getlevel();//查询权限
        this.selectSearch(); //查询待审批房源列表
        this.getHousingCondition(); //房源状态
        this.gethouseTypeList(); //建筑类型
        this.getEmployeeIdList();//提交人列表
        this.getApprovalList();//审批状态列表
    },
    methods: {
        //实勘图片放大
        HousingSolidImgList(val) {
            this.imgListShow1 = true;
            let list = [];
            val.map(item => {
                list.push(item.uri)
            })
            this.imgList = list;
        },
        //跳转审批
        toApproveManage() {
            this.$router.push({ path: "/approveManage" });
            sessionStorage.setItem('customerApplyId', this.details.applyId);
            this.HousingSolidVisible = false;
        },
        //查询列表
        selectSearch(val) {
            this.isRowColor = "";
            if (val) {
                this.pageNumber = 1;
                this.currentPage = 1;
            }
            let params = Object.assign({}, this.search);
            params["page.pageNumber"] = this.pageNumber * this.pageSize - this.pageSize;
            params["page.pageSize"] = this.pageSize;
            // params.permissionLevel = this.level;
            this.$post(querySurveyList, params).then(res => {
                if (res.success) {
                    this.KeyList = res.data;
                    this.total = res.total;
                    this.KeyList.map(item => {
                        if (item.submissionDate) {
                            item.submissionDate = item.submissionDate.replace("T", "    ");
                        }
                    });
                }
            });
        },
        //查询审批状态
        getApprovalList() {
            this.$post(checkStatusGet).then(res => {
                this.ApprovalList = res.data;
            })
        },
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.houseCode;
            this.isapplyId = row.applyId;
        },
        querySearchAsync(queryString, cb) {
            // 查询小区
            let params = {
                name: queryString
            };
            this.$post(communitynameQuery, params).then(res => {
                if (res.success) {
                    this.housingData = res.data;
                    let restaurants = this.housingData;
                    cb(restaurants);
                    this.search.residentialAreaId = "";
                    this.selectSearch(true);
                }
            });
        },
        handleSelect(item) {
            this.pageNumber = 1;
            this.pageSize = 20;
            this.currentPage = 1;
            this.search.residentialAreaId = item.residentialAreaId;
            this.ResidentialName = item.name;
            this.selectSearch(true);
        },
        //获取栋座
        getSimpleTung(val) {
            if (val) {
                let params = {
                    residentialAreaId: this.search.residentialAreaId
                }
                this.$post(simpleTung, params).then(res => {
                    this.simpleTungList = res.data;
                })
            }
        },
        //获取单元
        getSimpleUnit(val) {
            if (val) {
                let params = {
                    tungId: this.search.tungId
                }
                this.$post(simpleUnit, params).then(res => {
                    this.simpleUnitList = res.data;
                })
            }
        },
        //获取房源状态
        getHousingCondition() {
            this.HousingList = [
                { name: "出租", value: "LEASE" },
                { name: "出售", value: "SELL" }
            ];
        },
        // 查询建筑类型
        gethouseTypeList() {
            let params = {
                code: "areaArchitecturalType"
            };
            this.$post(dicGet, params).then(res => {
                if (res.success) {
                    this.houseTypeList = res.data;
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error"
                    });
                }
            });
        },
        // 获取签约人列表
        getEmployeeIdList() {
            let params = {
                name: "",
                status:'ENABLE',
            };
            this.$post(employeeQuery, params).then(res => {
                if (res.success) {
                    this.employeeIdList = res.data;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg
                    });
                }
            });
        },
        // 获取签约人列表
        // getApprovalList() {
        //     this.ApprovalList = [
        //         { name: "不限", value: "" },
        //         { name: "待提交", value: "WAITING_FOR_APPROVAL" },
        //         { name: "审批中", value: "TO_BE_AUDITED" },
        //         { name: "审批拒绝", value: "UNABLE" },
        //         { name: "审批同意", value: "UNABLE" }
        //     ];
        // },
        //跳转详情
        HousingDetails(id, type, employeeId) {
            if (type == "SECONDHAND") {
                sessionStorage.setItem("sellHousebuildId", id);
                this.$router.push({ path: "/buildDetail" });
            } else if (type == "RENTING") {
                sessionStorage.setItem("rentHousebuildId", id);
                this.$router.push({ path: "/rentingBuildDetail" });
            } else if (type == "SHOP_SALE") {
                sessionStorage.setItem("sellShopbuildId", id);
                this.$router.push({ path: "/sellShopDetails" });
            } else if (type == "SHOP_RENTAL") {
                sessionStorage.setItem("rentShopbuildId", id);
                this.$router.push({ path: "/rentShopDetails" });
            }
            sessionStorage.setItem("buildId", id);
            this.HousingSolidVisible = false;
        },
        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.selectSearch();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.selectSearch();
        },
        //操作
        operation(row) {
            // console.log(row.houseCode);
            this.permisList = [];
            // 实勘权限
            let params = {
                houseCode: row.houseCode,
            };
            this.$post(houseTypeDetail, params).then((res) => {
                if (res.success) {
                    let permisList = res.data.rflist;
                    if (permisList) {
                        permisList.map((item) => {
                            this.permisList.push(item.functionName);
                        });
                    }
                    // console.log(this.permisList,this.permisList.indexOf("实勘编辑"))
                    if (this.permisList.indexOf("实勘编辑") !== -1) {
                        this.HousingSolidVisible = true;
                        this.details = row;
                    } else {
                        this.$message.error('暂无权限！')
                    }
                }
            });
        },
        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        },
        removeHousingSolid() {
            this.selectSearch();
            this.HousingSolidVisible = false;
        },
    }
};
</script>
<style type="text/css" lang="less">
.waitHouse {
    height: 100%;

    .el-table .cell,
    .el-table th div,
    .el-table--border td:first-child .cell,
    .el-table--border th:first-child .cell {
        text-align: center;
    }
    .top_wrap {
        padding: 20px 30px;
        background: #fff;
        .key_top {
            display: flex;
            align-items: center;

            background: #fff;
            .add_btn {
                margin-left: 30px;
                width: 100px;
                height: 30px;
                margin-bottom: 10px;
                background: #5e75e6;
                color: white;
                outline: none;
                border: none;
            }
            .key_list {
                display: flex;
                flex-wrap: wrap;

                .conditions_list_item {
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    cursor: pointer;
                    > span {
                        font-size: 12px;
                    }
                    .el-input {
                        width: 120px;
                        height: 30px;

                        .el-input-group__append,
                        .el-input-group__prepend {
                            padding: 0 10px;
                            background: #cccccc;
                            border: none;
                        }

                        .el-input__inner {
                            border: none;
                            height: 30px;
                            border: 1px solid #dbdbdb;
                        }
                        .el-input__icon {
                            line-height: 30px;
                        }

                        .icon-icon_sousuo {
                            color: white;
                        }
                    }

                    .el-select {
                        .el-input {
                            width: 120px;
                            .el-input__inner {
                                width: 120px;
                                height: 30px;
                                border: none;
                                color: black;
                                padding: 0 10px;
                                border: 1px solid #dbdbdb;
                            }
                            .el-input__icon {
                                line-height: 30px;
                            }
                        }
                    }
                    .Residential {
                        .el-input__inner {
                            width: 120px;
                            height: 30px;
                            // border: none;
                            // background: #f5f5f5;
                        }
                        .el-input__icon {
                            line-height: 30px;
                        }
                    }
                    .idcode {
                        position: relative;
                        .el-input {
                            // margin-left: 10px;
                            .el-input__inner {
                                width: 100px;
                                height: 30px;
                                // border: none;
                                // background: #f5f5f5;
                                // padding: 0;
                            }
                            .el-input__icon {
                                line-height: 30px;
                            }
                        }
                        .el-range-editor.el-input__inner {
                            height: 30px;
                            line-height: 30px;
                            .el-range-separator {
                                height: 30px;
                                line-height: 30px;
                            }
                            .el-input__icon {
                                height: 30px;
                                line-height: 30px;
                            }
                        }
                    }
                }
                .many_item {
                    .el-select {
                        .el-input {
                            width: 180px;
                            .el-input__inner {
                                width: 180px;
                                height: 30px;
                                border: none;
                                color: black;
                                padding: 0 10px;
                                border: 1px solid #dbdbdb;
                            }
                            .el-input__icon {
                                line-height: 30px;
                            }
                        }
                    }
                }
            }

            //弹出框样式
            .el-dialog {
                width: 500px;

                .el-dialog__title {
                    color: #5e75e6;
                    font-size: 20px;
                }

                .el-dialog__close {
                    font-size: 26px;
                }

                .el-dialog__body {
                    padding-left: 0;
                    padding-right: 0;
                    padding-bottom: 0;
                }
            }
        }
        .key_top:first-child {
            .conditions_list_item {
                margin-bottom: 10px;
            }
        }
    }

    .key_list_wrap {
        height: 90%;

        .el-dialog {
            width: 600px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }

        .footer_pages {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }
        }
    }
    .mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        z-index: 3000;
        .close {
            width: 20px;
            position: absolute;
            top: 0;
            right: 200px;
            padding: 50px;
            z-index: 100 !important;
        }
        .delet {
            position: relative;
            width: 120px;
            padding-left: 36px;
            padding-right: 36px;
            margin-right: 20px;
            height: auto !important;
        }
        .set {
            position: relative;
            width: 120px;
            right: 0;
            padding-left: 36px;
            padding-right: 36px;
            margin-right: 20px;
            height: auto !important;
        }

        .download {
            border: none;
            background: #22ca85;
            color: #ffffff;
            position: relative;
            width: 120px;
            padding-left: 36px;
            padding-right: 36px;
            margin-right: 20px;
            height: auto !important;
        }

        .el-carousel__container {
            margin: 0 auto;
            width: 80%;
            height: 90vh;
            z-index: 99;
            .el-carousel__arrow {
                font-size: 50px !important;
                padding: 20px;
                width: 100px;
                height: 100px;
            }
        }

        .el-carousel__item {
            color: #475669;
            font-size: 18px;
            opacity: 0.75;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            overflow: visible;
            // min-height: 400px;
            .uploadtime {
                width: 100%;
                line-height: 24px;
                color: #fff;
                position: absolute;
                bottom: 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            > img {
                height: 90%;
            }
        }
    }
}
</style>
